import { render } from "./DepartmentPerformance.vue?vue&type=template&id=353e899f&scoped=true"
import script from "./DepartmentPerformance.vue?vue&type=script&lang=js"
export * from "./DepartmentPerformance.vue?vue&type=script&lang=js"

import "./DepartmentPerformance.vue?vue&type=style&index=0&id=353e899f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353e899f"]])

export default __exports__